import Employees from "../../../jsx/components/Dashboard/Employees/Employees";

const EmployeesWrapper = () => {
  return <Employees />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(EmployeesWrapper);
